<template>
  <td :class="['breakdown-value-cell', highlight ? 'highlight' : '']">
    <div class="value"><slot /></div>
    <div :class="{'analytics-diff-badge': true, 'diff-positive': isPositiveDiff, 'diff-negative': isNegativeDiff, 'diff-same': isSameDiff}">
      <i :class="{'fas': true, 'fa-caret-up': isPositiveDiff, 'fa-caret-down': isNegativeDiff, 'fa-minus': isSameDiff}"></i> <span v-if="!isSameDiff">{{formatPercent(displayDiffPercent, 0, true)}}</span>
    </div>
  </td>
</template>

<style scoped>
.breakdown-value-cell {
  position: relative;
}
.breakdown-value-cell.highlight > .value {
  font-weight: 600;
}
.breakdown-value-cell .value {
  display: inline-block;
  font-size: 0.825rem;
}
</style>

<script>
import Utils from '@/utils/utils'

export default {
  name: 'AnalyticsBreakdownValueCell',
  props: {
    value: Number,
    previous: Number,
    highlight: Boolean
  },
  computed: {
    diff() {
      return this.value - this.previous
    },
    isPositiveDiff() {
      return this.diff >= 0.1
    },
    isNegativeDiff() {
      return this.diff <= -0.1
    },
    isSameDiff() {
      return !this.isPositiveDiff && !this.isNegativeDiff
    },
    displayDiffPercent() {
      if(this.previous == 0)
        return 100

      return Utils.roundNumber(Math.abs((this.value - this.previous) / this.previous) * 100, 0)
    }
  }
}
</script>